import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const PhoneIcon = ({
  width = 16,
  height = 16,
  stroke = '#4c5956',
  fill = 'none',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 20 20"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.3337 14.1V16.6C18.3346 16.8321 18.2871 17.0618 18.1941 17.2745C18.1011 17.4871 17.9648 17.678 17.7937 17.8349C17.6227 17.9918 17.4208 18.1113 17.201 18.1856C16.9811 18.26 16.7482 18.2876 16.517 18.2667C13.9527 17.9881 11.4895 17.1118 9.32535 15.7084C7.31187 14.4289 5.6048 12.7219 4.32535 10.7084C2.917 8.53438 2.04055 6.0592 1.76702 3.48337C1.74619 3.25293 1.77358 3.02067 1.84743 2.80139C1.92129 2.58211 2.03999 2.38061 2.19599 2.20972C2.35199 2.03883 2.54186 1.9023 2.75351 1.80881C2.96517 1.71532 3.19397 1.66692 3.42535 1.66671H5.92535C6.32977 1.66273 6.72184 1.80594 7.02849 2.06965C7.33513 2.33336 7.53542 2.69958 7.59202 3.10004C7.69754 3.9001 7.89323 4.68565 8.17535 5.44171C8.28747 5.73998 8.31174 6.06414 8.24527 6.37577C8.17881 6.68741 8.0244 6.97347 7.80035 7.20004L6.74202 8.25837C7.92831 10.3447 9.65573 12.0721 11.742 13.2584L12.8004 12.2C13.0269 11.976 13.313 11.8216 13.6246 11.7551C13.9363 11.6887 14.2604 11.7129 14.5587 11.825C15.3147 12.1072 16.1003 12.3029 16.9004 12.4084C17.3052 12.4655 17.6749 12.6694 17.9391 12.9813C18.2034 13.2932 18.3438 13.6914 18.3337 14.1Z"
    />
  </svg>
);
